// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0eb7f3fa","455":"17070dca","865":"ef9beac6","977":"d5983798"}[chunkId] + ".chunk.js";
};